import React from "react";
import UserResetPassword from "../components/Login/UserResetPassword";

const UserResetPasswordPage = () => {
  return (
    <div>
      <UserResetPassword />
    </div>
  );
};

export default UserResetPasswordPage;
